import styled from 'styled-components';

export const CarouselLegendContainer = styled.div`
  width: 100%;
  position: absolute;
  bottom: 80px;
  display: flex;
  justify-content: center;
`;

export const CarouselLegendContent = styled.div`
  width: 100%;
  max-width: 1140px;
  text-align: left;
  color: #ffffff;
  text-shadow: 1px 1px 1px #000000;
`;

export const CarouselLegendTitle = styled.h1`
  font-size: 40px;
`;

export const CarouselLegendDescription = styled.p`
  margin-top: 16px;
  font-size: 24px;
  font-weight: 500;
`;
